import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-missing-email-warning-dialog",
	templateUrl: "./missing-email-warning-dialog.component.html",
	styleUrls: ["./missing-email-warning-dialog.component.css"],
})
export class MissingEmailWarningDialogComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.Username = this.dialogConfig.data.Username;
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	Username: string = "";

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////
}
